import React from 'react'
import "./CuponCard.css"
function CuponCard({ item }) {
  return (
    <div className='cupon_card_container'>
      <h2 className='mb-4'>{item && item.discount}% OFF</h2>
      {/* <p>No Minimum Purchase</p> */}
      <div>
        <span className='date'>        {item && item.start.substring(0, 10)}  ~  {item && item.end.substring(0, 10)}
        </span>
        <span className='code'>Code: {item && item.code}</span>
      </div>
    </div>
  )
}

export default CuponCard